// 9fbef606107a605d69c0edbcd8029e5d
import storesAndProductInventoryInfo from '@tcp/core/src/queries/storesAndProductInventoryInfo.query.graphql';
import userBopisStores from '@tcp/core/src/queries/userBopisStores.query.graphql';
import { isCanada } from '../../../utils';
import {
  getFormattedError,
  responseContainsErrors,
  ServiceResponseError,
} from '../../../utils/errorMessage.util';
import { executeStatefulGraphQLQuery } from '../../handler';
import {
  ERROR_MESSAGES_BOPIS,
  getDefaultStoresPlusInventorybyLatLngMapBox,
  getLocationStoresSfcc,
  storeAPIParser,
} from './pickupStoreModal';

export const submitGetBopisSearchByLatLng = ({ locationPromise }) => {
  return locationPromise.then((location) => {
    try {
      let errorMessage = '';
      if (location) {
        if (location.error === ERROR_MESSAGES_BOPIS.zeroResults) {
          return { errorMessage: ERROR_MESSAGES_BOPIS.noAddressFound };
        }
        // Validation for scenarios where location is coming as {} and code is breaking
        const { country } = location;
        if (typeof country === 'undefined') {
          return { location, errorMessage: '' };
        }
        // Validation to check if search is for same country, else show error message.
        if (country.toLowerCase() === 'us' && isCanada()) {
          errorMessage = ERROR_MESSAGES_BOPIS.caPostalCode;
        } else if (country.toLowerCase() === 'ca' && !isCanada()) {
          errorMessage = ERROR_MESSAGES_BOPIS.usZipCode;
        }
        return { location, errorMessage };
      }
      return { errorMessage: ERROR_MESSAGES_BOPIS.apiTimeoutError };
    } catch (e) {
      return { location, errorMessage: e };
    }
  });
};

export const getDefaultStoresPlusInventorybyLatLng = (reqObj) => {
  const { storeLocatorSwitches } = reqObj;
  const { FETCH_CLOSEST_STORE, SWITCH_TO_SFCC_FOR_STORE_INFO } = storeLocatorSwitches;
  if (FETCH_CLOSEST_STORE && SWITCH_TO_SFCC_FOR_STORE_INFO) {
    return getLocationStoresSfcc(reqObj);
  }
  return getDefaultStoresPlusInventorybyLatLngMapBox(reqObj);
};

export const getStoresPlusInventorybyLatLnggraph = ({
  quantity,
  distance,
  lat,
  lng,
  country,
  variantId,
  storeSearchCriteria,
  isCart = false,
}) => {
  const queryPayload = {
    latitude: parseFloat(lat),
    longitude: parseFloat(lng),
    distanceUnit: 'mi',
    maxDistance: distance ? parseInt(distance, 10) : 25, // assigning default value when no value is passed
    productId: variantId,

    countryCode: country,
    isCart,
  };
  if (storeSearchCriteria && storeSearchCriteria.length > 0) {
    queryPayload.postalCode = storeSearchCriteria;
  }

  const payload = {
    query: storesAndProductInventoryInfo,
    variables: queryPayload,
    type: 'query',
    fetchPolicy: 'no-cache',
  };
  let apiError = { error: ERROR_MESSAGES_BOPIS.noAddressFound };
  return executeStatefulGraphQLQuery(payload)
    .then((res) => {
      const stores =
        res?.data &&
        res?.data?.storeAndProductInventoryInfo &&
        res?.data?.storeAndProductInventoryInfo?.data;
      if (stores && stores.length) {
        return {
          stores: stores.map((store) => storeAPIParser(store, { requestedQuantity: quantity })),
        };
      }
      apiError = { error: ERROR_MESSAGES_BOPIS.noAddressFound };
      return { error: apiError.error, stores: [] };
    })
    .catch((err) => {
      if (err && err[0].errorMessage === ERROR_MESSAGES_BOPIS.storeNotFound) {
        apiError = { error: ERROR_MESSAGES_BOPIS.noAddressFound };
      } else if (err && err.errors) {
        apiError = { error: err[0].errorMessage };
      }
      return apiError;
    });
};

export const getCartStoresPlusInventorygraph = ({ quantity, variantId }) => {
  const queryPayload = {
    productId: variantId,
  };

  const payload = {
    query: userBopisStores,
    variables: queryPayload,
    type: 'query',
    fetchPolicy: 'no-cache',
  };
  return executeStatefulGraphQLQuery(payload)
    .then((res) => {
      if (responseContainsErrors(res)) {
        throw new ServiceResponseError(res);
      } else {
        const stores =
          res?.data && res?.data?.userBopisStores && res?.data?.userBopisStores?.results;
        if (stores && stores.length) {
          return stores.map((store) => storeAPIParser(store, { requestedQuantity: quantity }));
        }
        return [];
      }
    })
    .catch((err) => {
      throw getFormattedError(err);
    });
};
